export const DEFAULT = 'DEFAULT';
export const DIVIDENDS = 'DIVIDENDS';
export const TIPPED_WINNERS = 'TIPPED_WINNERS';
export const MANUAL_RECALC = 'MANUAL_RECALC';
export const DIVIDEND_RECALC = 'DIVIDEND_RECALC';
export const OWNWINPERCENTAGE_RECALC = 'OWNWINPERCENTAGE_RECALC';
export const PRESET_REDUCTION_RECALC = 'PRESET_REDUCTION_RECALC';

const betUpdateType = {
  DEFAULT,
  DIVIDENDS,
  DIVIDEND_RECALC,
  TIPPED_WINNERS,
  MANUAL_RECALC,
  PRESET_REDUCTION_RECALC,
  OWNWINPERCENTAGE_RECALC,
};

export default betUpdateType;
